"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var NumberInput_1 = require("atomicComponents/atoms/Forms/NumberInput");
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var DiscountSplitDropdown = function (_a) {
    var _b, _c;
    var onClose = _a.onClose, isDropdownOpen = _a.isDropdownOpen, item = _a.item;
    var _d = __read(react_1.default.useState(Math.round(item.discountSplit * 100)), 2), accFirmPercentVal = _d[0], setAccFirmPercent = _d[1];
    var _e = __read((0, hooks_1.useSubmitter)('recharged_customers', item.id), 2), updateCustomer = _e[0], submitting = _e[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var accFirmPercent = accFirmPercentVal === undefined
        ? Math.round(((_c = (_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.discountSplitMap) === null || _b === void 0 ? void 0 : _b.Xero) !== null && _c !== void 0 ? _c : 0) * 100)
        : accFirmPercentVal;
    var clientSplit = 1 - accFirmPercent / 100;
    var rmCustomValue = function () { return setAccFirmPercent(undefined); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateCustomer({ accFirmDiscountSplit: accFirmPercentVal === null ? (0, firestore_1.deleteField)() : accFirmPercent / 100 })];
                case 1:
                    _a.sent();
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, __assign({ onClickAway: onClose }, { children: (0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ anchorEl: isDropdownOpen, open: !!isDropdownOpen, onClose: onClose, tabIndex: -1, modalWidth: 275, transformOrigin: { vertical: 'top', horizontal: 'center' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2, pb: 0, tabIndex: -1 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, fontSize: 12, color: "riverstone" }, { children: "Discount split for" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, fontWeight: 600, pb: 2 }, { children: item.name })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", spacing: 2, width: 1 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", fontSize: 12, color: "neutral.main" }, { children: "Your firm" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 100 }, { children: (0, jsx_runtime_1.jsx)(NumberInput_1.PercentInput, { value: accFirmPercent, onChange: setAccFirmPercent, size: "small", InputProps: { sx: { input: { textAlign: 'right' } } } }) }))] })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", fontSize: 12, color: "neutral.main", noWrap: true, lineHeight: "32px", mr: 0.75 }, { children: "Your client" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", noWrap: true, lineHeight: "32px", width: 52, textAlign: "right" }, { children: (0, end2end_1.formatPercentagePrecise)(clientSplit) }))] }))] })), item.accFirmDiscountSplit !== undefined && (accFirmPercentVal === null
                        ? (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "The Xero discount split will be applied instead." }))
                        : (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", fullWidth: true, onClick: rmCustomValue, sx: { mt: 2 } }, { children: "Remove Custom Values" }))), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 2, direction: "row", pt: 2, pb: 1 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "neutral", size: "large", fullWidth: true, onClick: function () { return onClose(); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ size: "large", fullWidth: true, onClick: onSubmit, isSending: submitting }, { children: "Confirm" }))] }))] })) })) })));
};
exports.default = DiscountSplitDropdown;
